import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'

import { CompAlertWrapperCore } from '../core/alert/wrapper'

function CompAlertWrapper() {
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  // const action = useBuilderActionContextV2()

  return <CompAlertWrapperCore infos={infosProps} />
}

export { CompAlertWrapper }
